<template>
  <main class="keypad">
    <!-- TODO: Render dynamically -->
    <button class="keypad__key" @click="$emit('pin-input',1)">1</button>
    <button class="keypad__key" @click="$emit('pin-input',2)">2</button>
    <button class="keypad__key" @click="$emit('pin-input',3)">3</button>
    <button class="keypad__key" @click="$emit('pin-input',4)">4</button>
    <button class="keypad__key" @click="$emit('pin-input',5)">5</button>
    <button class="keypad__key" @click="$emit('pin-input',6)">6</button>
    <button class="keypad__key" @click="$emit('pin-input',7)">7</button>
    <button class="keypad__key" @click="$emit('pin-input',8)">8</button>
    <button class="keypad__key" @click="$emit('pin-input',9)">9</button>
    <button class="keypad__key" @click="$emit('pin-input','backspace')">
      <i class="fas fa-arrow-left"></i>
    </button>
    <button class="keypad__key" @click="$emit('pin-input',0)">0</button>
    <button class="keypad__key" @click="$emit('pin-input','clear')">
      <i class="fas fa-undo"></i>
    </button>
    <button class="keypad__submit" @click="$emit('pin-input','submit')">SUBMIT</button>
  </main>
</template>

<script>
export default {
  methods: {},
};
</script>

<style lang='scss' scoped>
$primary: #252525;
.keypad {
  display: grid;
  grid: repeat(5, 50px) / repeat(3, 50px);
  grid-gap: 15px;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 110%;
  bottom: 0px;
  background: #ffffff99;
  border-radius: 37px;
  padding: 10px;
  transform: scale(0);
  box-shadow: 0 0 5px $primary#{20};
  animation: reveal 200ms ease forwards;
  @keyframes reveal {
    100% {
      transform-origin: bottom left;
      transform: none;
    }
  }
  %button {
    color: $primary;
    height: 50px;
    padding: 10px;
    font-family: 'Nunito Sans', sans-serif;
    font-weight: bold;
    user-select: none;
    outline: none;
    &:active {
      transition: background 100ms ease;
      background:var(--primary);
    }
  }
  &__key {
    @extend %button;
    background: white;
    width: 50px;
    border-radius: 50%;
    box-shadow: 0 0 5px $primary#{80};
  }
  &__submit {
    @extend %button;
    background: var(--primary);
    grid-column: 1 / 4;
    border-radius: 3rem;
    font-size: 17px;
    box-shadow: 0 0 5px var(--primary);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Booking/PinEntryKeypad.vue